import { render, staticRenderFns } from "./BroadcastItem.vue?vue&type=template&id=56b94c5e&scoped=true"
import script from "./BroadcastItem.vue?vue&type=script&lang=js"
export * from "./BroadcastItem.vue?vue&type=script&lang=js"
import style0 from "./BroadcastItem.vue?vue&type=style&index=0&id=56b94c5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b94c5e",
  null
  
)

export default component.exports